import api from '../../api'

export const rebuildSnapshotsEndpoint = '/web/admin/job-snapshots/rebuild'
export const rebuildableJobsEndpoint = '/web/admin/job-snapshots/jobs'

export type RebuildSnapshotsRequest = { tenantId: number } | { jobId: number }

export type RebuildSnapshotsResult = {
  jobCount: number
}

export type RebuildableJob = {
  id: number
  name: string
  customerName: string
}

export const rebuildSnapshots = async (request: RebuildSnapshotsRequest): Promise<RebuildSnapshotsResult> => {
  return (await api.post(rebuildSnapshotsEndpoint, request)).data
}

export const getRebuildableJobs = async (tenantId: number): Promise<RebuildableJob[]> => {
  return (await api.get(rebuildableJobsEndpoint, { params: { tenantId } })).data
}
